export default "__VITE_ASSET__DmZkksbs__"